import { Link } from "react-router-dom";
import { PageMeta } from "@/components/common/PageMeta";

export default function NotFound() {
  return (
    <>
      <PageMeta title="Not found" />
      <section className="container-dbrf py-32 text-center">
        <p className="font-mono text-6xl font-bold text-[var(--cobalt)]">404</p>
        <h1 className="mt-4 font-display text-3xl font-bold text-navy">This page could not be found.</h1>
        <p className="mt-3 text-[var(--mineral)]">The link may be out of date, or the resource has not been published.</p>
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/" data-testid="notfound-home" className="rounded-full bg-[var(--navy)] px-6 py-3 text-sm font-semibold text-white btn-transition hover:bg-[var(--cobalt)]">Return home</Link>
          <Link to="/capabilities" className="rounded-full border border-[var(--line)] px-6 py-3 text-sm font-semibold text-navy btn-transition hover:border-[var(--cobalt)] hover:text-[var(--cobalt)]">Browse capabilities</Link>
        </div>
      </section>
    </>
  );
}
